<template>

    <div v-if="rtl" class="articleSection articleSection_right" :class="{'articleSection-image': image}">
        <div class="articleSection_content">
            <slot></slot>
        </div>
        <div class="articleSection_image" v-if="image">
            <ImageZoomable v-bind="image" :caption="caption"></ImageZoomable>
        </div>
    </div>

    <div v-else class="articleSection" :class="{'articleSection-image': image, 'articleSection-twoColumns': twoColumns}">
        <div class="articleSection_image" v-if="image">
            <ImageZoomable v-bind="image" :caption="caption"></ImageZoomable>
        </div>

        <div class="articleSection_content">
            <slot></slot>
        </div>
    </div>

</template>

<script>
    import ImageZoomable from "./ImageZoomable";
    export default {
        name: 'ArticleSection',
        components: {ImageZoomable},
        props: ['image', 'rtl', 'noZoom', 'twoColumns', 'caption'],
    };
</script>

<style scoped lang="scss">
    .articleSection{
        // min-height: 100vh;
        display: flex;
        margin: $G-default 0;

        @include breakpoint(xs){
            flex-wrap: wrap;
        }

        h2 {
            font-family: $F-Montserrat;
            font-size: 3rem;
            font-weight: $FW-semibold;
            text-transform: uppercase;
            margin: 0;
        }

        h3 {
            font-family: $F-Montserrat;
            font-size: 2.5rem;
            font-weight: $FW-semibold;
            margin: 0 0 $G-default/6 0;
        }

        p {
            margin: 0 0 $G-default/1.5 0;

            &:last-of-type {
                margin: 0;
            }
        }

        &_image{
            flex-basis: 50%;
            @include breakpoint(xs){
                flex-basis: 100%;
            }
        }

        &_content{
            flex: 1;
            @include breakpoint(xs){
                flex-basis: 100%;
            }
        }

        .imageZoomable{
            height: 100vh;
            @include breakpoint(xs){
                height: 50vh;
            }
        }

        &-twoColumns{
            &.encadre {
                background-color: transparent;
                margin: 0;
                padding: $G-default/1.5;

                .articleSection_content {

                    .boxed {
                        background-color:#f2f2f2;
                        padding: $G-default*1.5;
                        margin: 0 $G-default/1.5 ;
                    }
                }
            }

            .articleSection_content {
                display: flex;
                width: 100%;
                justify-content: center;
                padding: 0 10rem;

                @include breakpoint(xs){
                    flex-direction: column;
                    padding: 0;
                }

                .boxed {
                    margin: 0 $G-default;
                        @include breakpoint(xs){
                            margin: 0 auto;
                        }
                }
            }
        }


        

        &.map {
            background-color: #f2f2f2;
            padding: 0;
            margin: 3rem 0;
            .articleSection {
                &_content {
                    align-items: center;
                    display: flex;
                }
                &_image {
                    .imageZoomable {
                        height:50vh;
                    }
                }
            }
            
        }

        &-image{
            margin: 0;
            .articleSection_content{
                padding: $G-default*3 $G-default*6 $G-default*3 $G-default*2;
                @include breakpoint(xs){
                    padding: 5rem 0 $G-default*2 0;
                }
            }

            &.articleSection_right {
                .articleSection_content{
                    padding: $G-default*3 $G-default*2 $G-default*3 $G-default*6;
                }
            }
        }
    }
</style>